import { render, staticRenderFns } from "./EditCommunityVenue.vue?vue&type=template&id=5b4c5766"
import script from "./EditCommunityVenue.vue?vue&type=script&lang=js"
export * from "./EditCommunityVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports